<template>
    <page title="首页" style="background: #f5f5f5;">
        <div class="content">
            <div class="nav">
                <div class="nav-item" v-for="(item,index) in navList" :key="index"
                     @click="pushRouterName(item.routerName)">
                    <i class="nav_icon" :class="'nav_icon_'+(index+1)"></i>
                    <p>{{item.navName}}</p>
                </div>
            </div>
            <div class="message">
                <div class="title">消息中心</div>
                <div class="content">
                    <div v-infinite-scroll="loadMore"
                         infinite-scroll-disabled="loading"
                         infinite-scroll-immediate-check="false"
                         infinite-scroll-distance="10">
                        <div class="msg-item" v-for="(item,index) in msgList" :key="index" @click="findMsgDetail(item.id)">
                            <p :style="{color: item.status==1?'#000':'#666'}">{{item.title}}</p>
                            <span class="time">{{item.gmtCreate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </page>
</template>
<script>
    export default {
        data() {
            return {
                navList: [
                    {navName: '订单查询', routerName: 'OrderQuery'},
                    {navName: '运单查询', routerName: 'WaybillQuery'},
                    {navName: '轨迹查询', routerName: 'Transfer'},
                    {navName: '报价查询', routerName: 'Price'},
                    {navName: '问题件', routerName: 'Problem'},
                    {navName: '账单查询', routerName: 'Bill'},
                    {navName: '余额查询', routerName: 'Balance'},
                    {navName: '偏远查询', routerName: 'Remote'},
                ],
                loading: false,
                msgParams: {
                    pageIndex: 1,
                    pageSize: 10,
                },
                total: 0,
                msgList: []
            }
        },
        created() {
            document.title="首页";
            let companyNo = this.$util.get("companyNo");
            let userInfo = this.$util.get(companyNo + "_userInfo") || {};
            let clientNo = userInfo.clientNo || '';
            let accountType = userInfo.accountType || '';
            if (accountType == 0) { // 员工账号
                this.navList=[
                    {navName: '订单查询', routerName: 'OrderQuery'},
                    {navName: '报价查询', routerName: 'Price'},
                    {navName: '问题件', routerName: 'Problem'},
                    {navName: '偏远查询', routerName: 'Remote'},
                ]
            }
            this.msgParams.companyNo = companyNo;
            this.msgParams.clientNo = clientNo;
            this.searchData();
        },
        methods: {
            pushRouterName(routerName) {
                this.$router.push({name: routerName});
            },
            searchData() {
                if (this.loading) return false;
                this.msgList = [];
                this.getMessageList();
            },
            getMessageList(pageIndex = 1, pageSize = 10) {
                this.loading = true;
                this.msgParams.pageIndex = parseInt(pageIndex);
                this.msgParams.pageSize = parseInt(pageSize);
                this.http.send({
                    command: 'Message/getMessageList',
                    params: this.msgParams
                }).then(res => {
                    if (res.data.result_code === 0) {
                        this.msgList = this.msgList.concat(res.data.body.list || []);
                        this.total = res.data.body.totalCount;
                    }
                    this.loading = false;
                }).catch(err => {
                    this.loading = false;
                })
            },
            loadMore() {
                if (this.loading) return false;
                if (this.total === this.msgList.length) return false;
                this.msgParams.pageIndex++;
                this.getMessageList(this.msgParams.pageIndex);
            },
            findMsgDetail(id) {
                this.$router.push({name: 'MsgDetail', query: {id: id}});
            }
        }
    }
</script>
<style scoped>
    .nav {
        background-color: #fff;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        padding-top: 22px;
        margin-bottom: 10px;
    }
    .nav-item {
        width: 25%;
        text-align: center;
        margin-bottom: 28px;
        color: #191e25;
        font-size: 14px;
    }
    .nav_icon {
        display: inline-block;
        width: 44px;
        background-size: 100%;
        height: 44px;
        margin-bottom: 8px;
    }
    .nav_icon_1 {background-image: url("../assets/nav01.png");}
    .nav_icon_2 {background-image: url("../assets/nav02.png");}
    .nav_icon_3 {background-image: url("../assets/nav03.png");}
    .nav_icon_4 {background-image: url("../assets/nav04.png");}
    .nav_icon_5 {background-image: url("../assets/nav05.png");}
    .nav_icon_6 {background-image: url("../assets/nav06.png");}
    .nav_icon_7 {background-image: url("../assets/nav07.png");}
    .nav_icon_8 {background-image: url("../assets/nav08.png");}
    .message {
        background: #fff;
    }
    .message .title {
        border-top: 1px solid #eee;
        height: 48px;
        line-height: 48px;
        padding-left: 15px;
        font-size: 16px;
        color: #191e25;
    }
    .message .content {
        border-top: 1px solid #eee;
        padding: 0 15px;
    }
    .message .msg-item {
        border-bottom: 1px solid #eee;
        font-size: 12px;
        color: #191e25;
    }
    .message .msg-item:last-child {
        border-bottom: none;
    }
    .msg-item p {
        width: calc(100% - 120px);
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 48px;
    }
    .message .msg-item span {
        color: #999999;
        float: right;
        line-height: 48px;
    }
</style>



// WEBPACK FOOTER //
// src/page/main.vue